import { combineActions, handleActions } from 'redux-actions'
import { fromJS } from 'immutable'

import * as AppActions from 'actions/app'
import * as Actions from 'actions/gaio'

export const initialState = fromJS({
  projects: {
    items: [],
    total: 0
  },
  projectsCount: null,
  selectedProject: null,
  prompts: {
    items: [],
    total: 0
  },
  promptsStatistics: null,
  promptOptions: {
    items: [],
    total: 0
  },
  selectedPrompt: null,
  promptNews: {
    items: [],
    total: 0
  },
  sources: {
    items: [],
    total: 0
  },
  scorecard: [],
  suggestedPrompts: [],
  tags: []
})

export default handleActions({
  [Actions.createProjectSuccess]: (state, { payload }) => {
    const project = fromJS(payload)
    const projects = state.get('projects', initialState.get('projects'))
    const projectItems = projects.get('items', initialState.getIn(['projects', 'items']))
    const projectIndex = projectItems.findIndex(item => String(item.get('id')) === String(payload.id))
    const nextProjectItems = projectIndex === -1
      ? projectItems.unshift(project)
      : projectItems.set(projectIndex, project)
    const projectsTotal = projects.get('total', projectItems.size)

    return state
      .set('projects', projects
        .set('items', nextProjectItems)
        .set('total', projectIndex === -1 ? Math.max(projectsTotal + 1, nextProjectItems.size) : projectsTotal))
      .set('selectedProject', project)
  },
  [Actions.updateProjectSuccess]: (state, { payload }) => state.set('selectedProject', fromJS(payload)),
  [Actions.deleteProjectSuccess]: (state, { payload = {} }) => {
    const projectId = payload.id
    const projects = state.get('projects', initialState.get('projects'))
    const projectItems = projects.get('items', initialState.getIn(['projects', 'items']))
    const filteredProjectItems = projectId == null
      ? projectItems
      : projectItems.filter(project => String(project.get('id')) !== String(projectId))
    const projectRemoved = filteredProjectItems.size !== projectItems.size
    const projectsTotal = projects.get('total', projectItems.size)

    return state
      .set('projects', projects
        .set('items', filteredProjectItems)
        .set('total', projectRemoved ? Math.max(projectsTotal - 1, filteredProjectItems.size) : projectsTotal))
      .set('selectedProject', null)
      .set('prompts', initialState.get('prompts'))
      .set('promptsStatistics', initialState.get('promptsStatistics'))
      .set('promptOptions', initialState.get('promptOptions'))
      .set('suggestedPrompts', initialState.get('suggestedPrompts'))
      .set('sources', initialState.get('sources'))
  },
  [Actions.setSelectedProject]: (state, { payload }) => state
    .set('selectedProject', fromJS(payload))
    .set('prompts', initialState.get('prompts'))
    .set('promptsStatistics', initialState.get('promptsStatistics'))
    .set('promptOptions', initialState.get('promptOptions'))
    .set('suggestedPrompts', initialState.get('suggestedPrompts'))
    .set('sources', initialState.get('sources')),
  [Actions.searchProjectsSuccess]: (state, { payload: { projects, total } }) => state.set('projects', fromJS({ items: projects, total })),
  [Actions.fetchProjectsCountStart]: state => state.set('projectsCount', initialState.get('projectsCount')),
  [Actions.fetchProjectsCountSuccess]: (state, { payload: { total } }) => state.set('projectsCount', total),
  [Actions.searchPromptsStart]: state => state.set('prompts', initialState.get('prompts')),
  [Actions.searchPromptsSuccess]: (state, { payload: { prompts, total } }) => state.set('prompts', fromJS({ items: prompts, total })),
  [Actions.fetchPromptsStatisticsStart]: state => state.set('promptsStatistics', initialState.get('promptsStatistics')),
  [Actions.fetchPromptsStatisticsSuccess]: (state, { payload }) => state.set('promptsStatistics', fromJS(payload)),
  [Actions.fetchPromptOptionsStart]: state => state.set('promptOptions', initialState.get('promptOptions')),
  [Actions.fetchPromptOptionsSuccess]: (state, { payload: { prompts, total } }) => (
    state.set('promptOptions', fromJS({ items: prompts, total }))
  ),
  [Actions.searchPromptStart]: state => state
    .set('selectedPrompt', initialState.get('selectedPrompt'))
    .set('promptNews', initialState.get('promptNews')),
  [Actions.searchPromptSuccess]: (state, { payload }) => state.set('selectedPrompt', fromJS(payload)),
  [Actions.fetchPromptNewsStart]: state => state.set('promptNews', initialState.get('promptNews')),
  [Actions.fetchPromptNewsSuccess]: (state, { payload: { news, total } }) => (
    state.set('promptNews', fromJS({ items: news, total }))
  ),
  [Actions.sourcesRequestSuccess]: (state, { payload: { sources, total } }) => (
    state.set('sources', fromJS({ items: sources, total }))
  ),
  [Actions.sourcesRequestStart]: state => state.set('sources', initialState.get('sources')),
  [Actions.scorecardRequestSuccess]: (state, { payload }) => (
    state.set('scorecard', fromJS(payload))
  ),
  [Actions.scorecardRequestStart]: state => state.set('scorecard', initialState.get('scorecard')),
  [Actions.updatePromptSuccess]: (state, { payload }) => {
    const selectedPrompt = state.get('selectedPrompt')
    const prompts = state.getIn(['prompts', 'items'], initialState.getIn(['prompts', 'items']))
    const promptIndex = prompts.findIndex(prompt => prompt.get('id') === payload.id)
    let nextState = state

    if (selectedPrompt && selectedPrompt.get('id') === payload.id) {
      nextState = nextState.update('selectedPrompt', prompt => prompt.merge(fromJS(payload)))
    }

    if (promptIndex !== -1) {
      nextState = nextState.updateIn(['prompts', 'items', promptIndex], prompt => prompt.merge(fromJS(payload)))
    }

    return nextState
  },
  [Actions.searchTagsSuccess]: (state, { payload }) => state.set('tags', fromJS(payload)),
  [Actions.fetchSuggestedPromptsStart]: state => state.set('suggestedPrompts', initialState.get('suggestedPrompts')),
  [Actions.fetchSuggestedPromptsSuccess]: (state, { payload }) => state.set('suggestedPrompts', fromJS(payload)),
  [Actions.setSelectedPrompt]: (state, { payload }) => state.set('selectedPrompt', fromJS(payload)),

  [combineActions(
    Actions.resetState,
    AppActions.resetState
  )]: () => initialState
}, initialState)
